import styled from "styled-components";

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 64px);
  margin-top: 0px;
  position: relative;
  padding-top: 20px;
  padding-bottom: 20px;
  border-radius: 30px;
  background: #FFFFFF;
  overflow: auto;

  @media print {
      overflow: visible !important;
  }

  @media only screen and (min-width:768px) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    position: relative;
    padding: 40px;
    padding-bottom: 32px;
    border-radius: 20px;
    border: 10px solid ${window?.settings?.sidebar_color ?? '#04333b'};
    scrollbar-width: thin;

    scrollbar-color: #E3E3E3 transparent;

    ::-webkit-scrollbar {
      width: 16px;
      height: 16px; 
      background: transparent;
    }

    ::-webkit-scrollbar-track-piece  {
      background: transparent;
    }

    ::-webkit-scrollbar-thumb:vertical {
      background: linear-gradient(to left, #E3E3E3 4px, transparent 0%);
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:horizontal {
      background: linear-gradient(to top, #E3E3E3 4px, transparent 0%);
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #E3E3E3;
    }
  }
`; 